import { CSSProperties } from "react";

// Szerokości kolumn tabeli na stronie 2 (widok desktop). Nagłówek i wiersze biorą je
// z jednego miejsca. Wcześniej nagłówek miał 15/49/18,5/5/19,5 % (suma 107 %),
// a wiersze 25/28/10/5/25 % plus margines 8 % przed ceną - żadna kolumna nagłówka
// nie stała nad swoją zawartością ("Preis inkl. MwSt." wisiał nad ikonami).
// Suma jest ta sama co wcześniej (101 %), ale martwy odstęp 8 % przed ceną trafił
// do kolumny cech i do kolumny ceny: ikony mają więcej miejsca, a nagłówek
// "Preis inkl. MwSt. 19%" mieści się w dwóch linijkach zamiast trzech.
export const COL_PRODUCT: CSSProperties = { flexBasis: "25%", flexGrow: 0 };
export const COL_FEATURES: CSSProperties = { flexBasis: "32%", flexGrow: 0 };
export const COL_PRICE: CSSProperties = {
  flexBasis: "14%",
  flexGrow: 0,
  minWidth: "130px",
};
export const COL_EXPAND: CSSProperties = { flexBasis: "5%", flexGrow: 0 };
export const COL_SELECT: CSSProperties = { flexBasis: "25%", flexGrow: 0 };
